module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/point02-1d7366b3cca8f9a92e9a630e0a59f8e0.png";